import { Link, useRouterState } from "@tanstack/react-router";
import { useAuditBooking } from "@/components/layout/AuditBookingContext";
import { pushAuditStart } from "@/lib/analytics";


export function MobileStickyCTA() {
  const { location } = useRouterState();
  const { hasResult, openBooking } = useAuditBooking();
  if (location.pathname.startsWith("/contact")) return null;


  const isAuditPage = ["/audit", "/audit/", "/audit/e", "/audit/e/"].includes(location.pathname);
  const showBooking = isAuditPage && hasResult;

  return (
    <div
      className="mobile-sticky-cta flex md:hidden items-center justify-between"
      role="complementary"
      aria-label={showBooking ? "Book your 30-min review" : "Get your free audit"}
      style={{
        position: "fixed",
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 60,
        background: "rgba(251,250,246,0.92)",
        backdropFilter: "blur(10px)",
        borderTop: "1px solid rgba(0,47,167,0.16)",
        padding: "10px 16px",
        gap: 12,
        paddingBottom: "calc(10px + env(safe-area-inset-bottom))",
      }}
    >
      <div
        className="mono shrink-0 whitespace-nowrap"
        style={{
          fontSize: 10.5,
          letterSpacing: "0.16em",
          textTransform: "uppercase",
          color: "rgba(0,47,167,0.62)",
        }}
      >
        {showBooking ? "Free review" : "Free audit"}
      </div>
      {showBooking ? (
        <button
          type="button"
          className="whitespace-nowrap"
          onClick={openBooking}
          style={{
            display: "inline-flex",
            alignItems: "center",
            gap: 6,
            background: "#8a6f3f",
            color: "#fff",
            fontFamily: '"IBM Plex Mono", "IBM Plex Mono Fallback", monospace',
            fontSize: 11.5,
            letterSpacing: "0.08em",
            textTransform: "uppercase",
            padding: "11px 16px",
            borderRadius: 4,
            minHeight: 44,
            lineHeight: 1,
            border: "none",
            cursor: "pointer",
          }}
        >
          Book your 30-min review →
        </button>
      ) : (
        <Link
          to="/audit"
          className="whitespace-nowrap"
          onClick={() => pushAuditStart("footer")}
          style={{
            display: "inline-flex",
            alignItems: "center",
            gap: 6,
            background: "#8a6f3f",
            color: "#fff",
            fontFamily: '"IBM Plex Mono", "IBM Plex Mono Fallback", monospace',
            fontSize: 11.5,
            letterSpacing: "0.08em",
            textTransform: "uppercase",
            padding: "11px 16px",
            borderRadius: 4,
            minHeight: 44,
            lineHeight: 1,
          }}
        >
          Get your free audit →
        </Link>
      )}

    </div>
  );
}
